export const formatARS = (value: number): string =>
  `$${value.toLocaleString('es-AR')}`
